<template>
  <div class="table-container">
    <div class="row justify-between">
      <h3 class="table-container__heading">{{ $t("debts") }}</h3>
      <div class="table-container__controls controls">
        <date-picker
          :lang="$t('short lang')"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          v-model="toDebitDate"
          @change="handleDatePickerChange"
          :clearable="false"
          :placeholder="$t('select date')"
          :not-after="new Date()"
          format="DD.MM.YYYY"
        />
        <!--                :value="incomeDateRange"-->
      </div>
    </div>
    <table class="table-container__table table">
      <div v-show="isTableLoading" class="table__preloader">
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <thead>
        <tr>
          <td class="table__head">{{ $t("debit type") }}</td>
          <td class="table__head" style="width: 25%">
            {{ $t("issuer") }}
          </td>
          <td class="table__head">ISIN</td>
          <td class="table__head">{{ $t("trade code") }}</td>
          <td class="table__head">{{ $t("payment purpose") }}</td>
          <td class="table__head align-center">{{ $t("summ") }}</td>
          <td class="table__head">{{ $t("currency") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cash in filteredUserDebit"
          :key="String(cash.ISIN) + String(cash.TRADE_CODE)"
        >
          <td class="table__body">
            {{ cash.DEBTYPE }}
          </td>
          <td class="table__body" style="overflow-x: hidden">
            {{ cash.FT_NAME }}
          </td>
          <td class="table__body">{{ cash.ISIN }}</td>
          <td class="table__body">{{ cash.TRADE_CODE }}</td>
          <td class="table__body">{{ cash.PAYMENT_PURPOSE }}</td>
          <td class="table__body align-center">
            {{ formatMoney(cash.CURRENCY_AMOUNT) }}
          </td>
          <td class="table__body">{{ cash.CURRENCY_CODE }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import DatePicker from "vue2-datepicker";
import { replaceCommas, formatMoney, income } from "@/helpers/money";
import { isLoading } from "@/helpers/loading";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "date-picker": DatePicker
  },
  data() {
    return {
      toDebitDate: moment()
        .subtract(1, "days")
        .format("DD.MM.YYYY")
    };
  },
  computed: {
    isTableLoading() {
      return isLoading(this.userDebit);
    },
    filteredUserDebit() {
      // Перехватываем начальное сотояние null, а также другие ошибки
      if (!this.userDebit) {
        return [];
      }
      return this.userDebit;
    },
    ...mapGetters(["userDebit", "displayingCurrency", "currencySign", "rate"])
  },
  methods: {
    formatMoney,
    getIncome(amount, dealAmount) {
      return income(replaceCommas(amount), replaceCommas(dealAmount));
    },

    // Возвращаем класс для окраски блока в зависимости от дохода (красный - убыток, зеленый - доход)
    getIncomeColor(income) {
      if (Math.sign(income) === 1) {
        return "table__body_green";
      } else if (Math.sign(income) === -1) {
        return "table__body_red";
      }
    },
    handleDatePickerChange(date) {
      this.$store.dispatch("changeToDebitDate", date);
      //   // Очищаем данные о доходности, чтобы отобразить лоадер
      //   this.$store.dispatch("clearIncomeData");
      //   // Отправляем новую дату в глобальное хранилище
      //   this.setSelectedDateRange(dateRange);
      //   // Загружаем данные о доходности на основе выбранного промежутка даты
      //   this.$store.dispatch("fetchIncomeData");
      // },
      // // Устанавливаем дату в глобальное хранилище
      // setSelectedDate(date) {
      //   this.$store.dispatch("setIncomeDateRange", date);
    }
  },
  mounted() {
    // Если портфель еще не был загружен, то загружаем его
    this.$store.dispatch("fetchUserDebit");
  }
};
</script>

<style scoped>
.total {
  text-align: right;
  margin: 55px;
}
.total span {
  padding: 5px;
}
.table-container {
  padding: 30px 30px 0;
}

.table-container__heading {
  font-size: 36px;
  font-weight: normal;
}

.table-container__select:not(:first-child) {
  margin-left: 15px;
}

.table {
  position: relative;
  margin: 40px 0 0;
}
.table__body {
  font-size: 14px;
}
.table__body:first-child,
.table__head:first-child {
  padding-left: 0px;
}
.table__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.controls {
  height: 39px;
}

.controls__item {
  height: 100%;
  padding: 0 12px;
  font-size: 15px;
  background-color: #ffffff;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}

.controls__date-picker {
  border: none;
}

@media all and (max-width: 1600px) {
  .table-container {
    padding: 30px 25px 0;
  }
}
@media all and (max-width: 1200px) {
  .table-container {
    padding: 20px 15px 0;
  }
  .title {
    font-size: 26px;
  }
  .table__body {
    font-size: 12px;
  }
  .table__head {
    font-size: 12px;
  }
}
</style>
